import Paper from '@material-ui/core/Paper'
import { Grid} from '@material-ui/core';
import Subtitle from "@base/Subtitle"
import AplicarLegenda from '@base/AplicarLegenda';
import {useCallback, useEffect, useRef, useState} from "react"
import escolaService from "@services/EscolaService"
import Toast from "@base/Toast";
import useStyles from "./Style";

export const ListagemArquivosRegistrados = (props) => {
  const [, setLoading] = useState(false);

  const [cartoesN1, setCartoesN1] = useState([]);
  const [cartoesN2, setCartoesN2] = useState([]);
  const [cartoesN3, setCartoesN3] = useState([]);
  const [qtdN1Previsto, setQtdN1Previsto] = useState(0);
  const [qtdN2Previsto, setQtdN2Previsto] = useState(0);
  const [qtdN3Previsto, setQtdN3Previsto] = useState(0);
  const toastRef = useRef(null);
  const classes = useStyles();

  const carregaCartoes = useCallback(() => {
    console.log(props.inep)
    if (props.inep !== undefined && props.inep !== "") {
      escolaService.buscarCartoesIMPAPorEscola(props.processo.id, props.inep).then(response => {
        if (response.status === 200) {
          const { n1, n2, n3 } = response.data.cartoes;
          setCartoesN1(n1.cartoes);
          setCartoesN2(n2.cartoes);
          setCartoesN3(n3.cartoes);
          setQtdN1Previsto(response.data.qtdAlunosN1Previsto);
          setQtdN2Previsto(response.data.qtdAlunosN2Previsto);
          setQtdN3Previsto(response.data.qtdAlunosN3Previsto);
        }
      }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Buscar os Cartões da Escola."));
    }
    setLoading(false)
  }, [props.inep, props.processo.id]);

  useEffect(() => {carregaCartoes()}, [
    carregaCartoes,
    props.refresh,
    props.inep,
    props.processo.id
  ]);

  return (
    <>
      <Toast ref={toastRef} />

    <Grid container sm={12} lg={12}>
      <Grid item sm={12} lg={12}>
        <Paper className={classes.wrapper} elevation={2}>
          <Subtitle>
            Cartões Recebidos (Origem IMPA)
          </Subtitle>
          <Grid item sm={12} style={{marginBottom: '20px'}}>
            <AplicarLegenda n1={"Previsto N1: " + qtdN1Previsto} n2={"Previsto N2: " + qtdN2Previsto} n3={"Previsto N3: " + qtdN3Previsto} />
          </Grid>
          <Grid alignItems="center" container spacing={1} style={{ fontWeight: "bold" }}>
            <Grid item sm={4}>
              Nivel 1 ({cartoesN1.length})
            </Grid>
            <Grid item sm={4}>
              Nivel 2 ({cartoesN2.length})
            </Grid>
            <Grid item sm={4}>
              Nivel 3 ({cartoesN3.length})
            </Grid>
          </Grid>
          <Grid  container spacing={1}>
            <Grid item sm={4}>
              {cartoesN1.map(c => <li>{c.codigo}</li>)}
            </Grid>
            <Grid item sm={4}>
              {cartoesN2.map(c => <li>{c.codigo}</li>)}
            </Grid>
            <Grid item sm={4}>
              {cartoesN3.map(c => <li>{c.codigo}</li>)}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
    </>
  )
}
export default ListagemArquivosRegistrados;
